import { Component } from "@theme/component";

/**
 * A custom element that manages a carousel.
 *
 * @extends {Component}
 */
export default class CarouselComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.initCarousel();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  getConfig() {
    const navigation = this.showNavigation
      ? {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }
      : null;
    const pagination = this.showPagination
      ? {
          el: ".swiper-pagination",
        }
      : null;
    const scrollbar = this.showScrollbar
      ? {
          el: ".swiper-scrollbar",
        }
      : null;

    const autoplay = this.autoplay
      ? {
          delay: this.autoplayDelay,
        }
      : null;
    return {
      loop: this.loop,
      slidesPerView: this.slidesAuto ? "auto" : this.slidesPerView,
      spaceBetween: this.spaceBetween,
      centeredSlides: this.centeredSlides,
      initialSlide: this.initialSlide,
      autoplay: autoplay || false,
      navigation: navigation || false,
      pagination: pagination || false,
      scrollbar: scrollbar || false,
      breakpoints: {
        768: {
          slidesPerView: this.slidesAuto ? "auto" : this.slidesPerViewDesktop,
          spaceBetween: this.spaceBetweenDesktop,
        },
      },
    };
  }

  initCarousel() {
    // @ts-ignore
    const swiper = new Swiper(
      this.querySelector("[ref='swiperCarousel']"),
      this.getConfig()
    );

    this.swiper = swiper;
  }
  get loop() {
    const loop = this.getAttribute("loop");
    if (!loop) throw new Error("Loop is required");
    return loop === "true" ? true : false;
  }

  get slidesAuto() {
    const slidesAuto = this.getAttribute("slides-auto");
    if (!slidesAuto) throw new Error("Slides auto is required");
    return slidesAuto === "true" ? true : false;
  }

  get slidesPerView() {
    const slidesPerView = this.getAttribute("slides-per-view");
    if (!slidesPerView) throw new Error("Slides per view is required");
    return Number(slidesPerView);
  }

  get slidesPerViewDesktop() {
    const slidesPerViewDesktop = this.getAttribute("slides-per-view-desktop");
    if (!slidesPerViewDesktop)
      throw new Error("Slides per view desktop is required");
    return Number(slidesPerViewDesktop);
  }

  get spaceBetween() {
    const spaceBetween = this.getAttribute("space-between");
    if (!spaceBetween) throw new Error("Space between is required");
    return Number(spaceBetween);
  }

  get spaceBetweenDesktop() {
    const spaceBetweenDesktop = this.getAttribute("space-between-desktop");
    if (!spaceBetweenDesktop)
      throw new Error("Space between desktop is required");
    return spaceBetweenDesktop;
  }

  get centeredSlides() {
    const centeredSlides = this.getAttribute("centered-slides");
    if (!centeredSlides) throw new Error("Centered slides is required");
    return centeredSlides === "true" ? true : false;
  }

  get initialSlide() {
    const initialSlide = this.getAttribute("initial-slide");
    if (!initialSlide) throw new Error("Initial slide is required");

    return Number(initialSlide);
  }

  get autoplay() {
    const autoplay = this.getAttribute("autoplay");
    if (!autoplay) throw new Error("Autoplay is required");
    return autoplay === "true" ? true : false;
  }

  get autoplayDelay() {
    const autoplayDelay = this.getAttribute("autoplay-delay");
    if (!autoplayDelay) throw new Error("Autoplay delay is required");
    return Number(autoplayDelay);
  }

  get showNavigation() {
    const showNavigation = this.getAttribute("show-navigation");
    if (!showNavigation) throw new Error("Show navigation is required");
    return showNavigation === "true" ? true : false;
  }

  get showPagination() {
    const showPagination = this.getAttribute("show-pagination");
    if (!showPagination) throw new Error("Show pagination is required");
    return showPagination === "true" ? true : false;
  }

  get showScrollbar() {
    const showScrollbar = this.getAttribute("show-scrollbar");
    if (!showScrollbar) throw new Error("Show scrollbar is required");
    return showScrollbar === "true" ? true : false;
  }
}

if (!customElements.get("carousel-component")) {
  customElements.define("carousel-component", CarouselComponent);
}
